export const CTAButton = ({
	onClick,
	label,
}: {
	onClick: () => void;
	label?: string;
}) => {
	return (
		<button
			className="fixed bottom-4 right-8 rounded-full px-6 py-3 border-4 font-bold z-50 text-white bg-primary-darkViolet border-secondary-lemon hover:bg-secondary-lemon hover:text-primary-lightViolet hover:border-primary-lightViolet"
			onClick={onClick}
		>
			{label}
		</button>
	);
};
